import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthAPI } from "../api/AuthAPI";

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadBlogs(page);
  }, [page]);

  async function loadBlogs(p) {
    try {
      setLoading(true);

      const res = await AuthAPI.getAllBlogs({
        page: p,
        limit: 10,
      });

      setBlogs(res.data?.data || []);
      setTotalPages(res.data?.settings?.total_pages || 1);
    } catch (err) {
      console.error("Failed to load blogs", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="text-black font-poppins mt-10 md:mt-0">
      {/* PAGE HEADER */}
      <section className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-center text-white">
        <h1 className="text-4xl font-bold">Blog</h1>
      </section>

      {/* BLOG LIST */}
      <section className="max-w-7xl mx-auto px-4 py-12">
        {loading && <div className="text-center py-10">Loading blogs...</div>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <article key={blog.id} className="rounded-lg overflow-hidden">
              {/* IMAGE */}
              <Link
                to={`/blog/${blog.id}`}
                className="block overflow-hidden rounded-tr-[80px] rounded-bl-[80px]"
              >
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-48 object-cover"
                />
              </Link>

              {/* CONTENT */}
              <div className="p-5">
                <h2 className="text-lg font-semibold mb-2">
                  <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
                </h2>

                <p className="text-sm text-gray-700 mb-4 line-clamp-3">
                  {blog.content?.replace(/<[^>]+>/g, "")}
                </p>

                <Link
                  to={`/blog/${blog.id}`}
                  className="text-sm font-medium text-indigo-600 hover:underline"
                >
                  Read more →
                </Link>
              </div>
            </article>
          ))}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="mt-12 flex items-center justify-center gap-2">
            {/* PREV */}
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              className={`px-4 py-2 border rounded ${
                page === 1
                  ? "opacity-40 cursor-not-allowed"
                  : "hover:bg-gray-100"
              }`}
            >
              Prev
            </button>

            {/* PAGE NUMBERS */}
            {Array.from({ length: totalPages }).map((_, i) => {
              const p = i + 1;
              return (
                <button
                  key={p}
                  onClick={() => setPage(p)}
                  className={`px-4 py-2 border rounded ${
                    p === page
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "hover:bg-gray-100"
                  }`}
                >
                  {p}
                </button>
              );
            })}

            {/* NEXT */}
            <button
              disabled={page === totalPages}
              onClick={() => setPage((p) => p + 1)}
              className={`px-4 py-2 border rounded ${
                page === totalPages
                  ? "opacity-40 cursor-not-allowed"
                  : "hover:bg-gray-100"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </section>
    </div>
  );
}
